export enum RaffleDefaultTicketStatusEnum {
  AVAILABLE = "a",
  UNAVAILABLE = "u",
  PENDING = "p", // payment pending
}

export type RaffleDefaultTicketStatusTypes = `${RaffleDefaultTicketStatusEnum}`;
